import "./CategoryDetailListLink.scss";
import { Link } from "react-router-dom";
import { routesMap } from "../../../../../../routes";

/**
 * @function CategoryDetailListLink CategoryDetailListLink components
 * @returns {JSX.Element}
*/
const CategoryDetailListLink = ( { voci, isSection } ) => {

    return (
        <>
            { voci?.length ? ( <div className="CategoryDetailListLink my-3">
                <div className="CategoryDetailListLink__tiltle" role="contentinfo" tabIndex="0" aria-label="contenuti sezione">{ isSection ? "CONTENUTI SEZIONE" : "CONTENUTI"}</div>
                <ul className="CategoryDetailListLink_list mt-4">
                    { voci?.map( item => {
                        return (
                            <li key={ item?.idContenuto ? item?.idContenuto : item?.id } className="CategoryDetailListLink__listItem">
                                <div className="d-flex">
                                    <Link
                                        to={`${routesMap.DETAGLIO_CATEGORIA}/${item?.idContenuto ? item?.idContenuto : item?.id}`}
                                        rel={`rel${item?.idContenuto || item?.id}`}
                                        className="custom-link" 
                                        role="link" 
                                        tabIndex="0"
                                    >{item?.nome}</Link>
                                </div>
                            </li>
                        );
                    } ) }
                </ul>
            </div> ) : null }

        </>
    );
};

CategoryDetailListLink.defaultProps = {};

export default CategoryDetailListLink;